<template>
    <div class="feed-trans-page p-3">
        
        <!-- ສ່ວນການຄົ້ນຫາ ແລະ ຈັດການຂໍ້ມູນ -->
        <b-card class="shadow-sm border-0 mb-4 bg-white rounded-lg">
            <template #header>
                <div class="d-flex align-items-center justify-content-between py-1">
                    <h5 class="mb-0 text-primary font-weight-bold">
                        <b-icon icon="filter-square-fill" class="mr-2"></b-icon>
                        ຄົ້ນຫາ ແລະ ຈັດການຂໍ້ມູນ
                    </h5>
                    <b-button v-show="menu.addnew" variant="success" @click="addnew" class="px-3 shadow-sm font-weight-bold">
                        <b-icon icon="plus-circle" class="mr-1"></b-icon> {{ $t("button.add") }}
                    </b-button>
                </div>
            </template>

            <b-row align-v="end">
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄົ້ນຫາຕາມ:</label>
                    <b-form-select v-model="field" :options="findfied" class="rounded-pill border-primary-light">
                        <template #first>
                            <b-form-select-option value="" disabled>-- ເລືອກຫົວຂໍ້ --</b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ຄຳຄົ້ນຫາ:</label>
                    <b-form-input type="text" v-model="find" placeholder="ຕ້ອງການຄົ້ນຫາ..." class="rounded-pill"></b-form-input>
                </b-col>
                <b-col cols="12" md="3" class="mb-2 mb-md-0">
                    <label class="small text-muted font-weight-bold mb-1">ວັນທີ:</label>
                    <b-form-datepicker id="fdate" v-model="fdate" placeholder="ວັນທີ" locale="lo" class="rounded-pill"></b-form-datepicker>
                </b-col>
                <b-col cols="12" md="3">
                    <b-button variant="primary" @click="onSearch" block class="rounded-pill shadow-sm font-weight-bold">
                        <b-icon icon="search" class="mr-1"></b-icon> ຄົ້ນຫາຂໍ້ມູນ
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

        <!-- ຕາຕະລາງສະແດງຂໍ້ມູນ -->
        <b-card no-body class="shadow-sm border-0 overflow-hidden rounded-lg">
            <b-table 
                head-variant="light" 
                hover 
                striped
                :fields="fields" 
                :items="items" 
                class="trans-table mb-0" 
                responsive="sm"
            >
                <!-- ລຳດັບ -->
                <template #cell(index)="data">
                    <span class="text-muted small font-weight-bold">{{ data.index + 1 }}</span>
                </template>

                <!-- Format ສະແດງຜົນຈຳນວນເງິນ (Amount) -->
                <template #cell(amount)="data">
                    <div class="text-right font-weight-bold text-success">
                        {{ data.value | format }}
                    </div>
                </template>

                <!-- Format ສະແດງຜົນລວມເງິນ (Total) -->
                <template #cell(total)="data">
                    <div class="text-right font-weight-bold text-primary">
                        {{ data.value | format }}
                    </div>
                </template>

                <!-- ປຸ່ມຈັດການ (Action) -->
                <template #cell(action)="data">
                    <div class="d-flex justify-content-center align-items-center">
                        <b-button v-show="menu.edit" variant="link" size="sm" class="text-info mr-2 p-0 action-btn" @click="edit(data.item._id)" v-b-tooltip.hover title="ແກ້ໄຂ">
                            <b-icon icon="pencil-square" font-scale="1.2"></b-icon>
                        </b-button>
                        <b-button v-show="menu.del" variant="link" size="sm" class="text-danger p-0 action-btn" @click="del(data.item._id)" v-b-tooltip.hover title="ລຶບ">
                            <b-icon icon="trash-fill" font-scale="1.2"></b-icon>
                        </b-button>
                    </div>
                </template>
            </b-table>
        </b-card>

        <!-- Loading ຂໍ້ມູນແບບ Infinite -->
        <div class="mt-4 pb-5 text-center">
            <infinite-loading @infinite="infiniteHandler" spinner="spiral">
                <div slot="spinner" class="py-3">
                    <b-spinner variant="primary" small label="Loading..."></b-spinner>
                    <span class="ml-2 text-muted small">ກຳລັງໂຫຼດຂໍ້ມູນ...</span>
                </div>
                <div slot="no-more" class="py-3 text-muted small italic">-- ສິ້ນສຸດຂໍ້ມູນ --</div>
                <div slot="no-results" class="py-3 text-muted small italic">-- ບໍ່ພົບຂໍ້ມູນ --</div>
            </infinite-loading>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import InfiniteLoading from "vue-infinite-loading";
import moment from 'moment'
export default {

    data() {
        return {
            page: 0,
            field: '',
            find: '',
            fdate: '',
            menuid: this.$route.query.id,
            pkey: "",
            table: "",
            fields: [],
            items: [],
            findfied: [],
            menu: [],
            user:[]
        }
    },
    components: {
        InfiniteLoading,
    },
    filters: {
        format(number) {
            if (number === null || number === undefined) return '0';
            return new Intl.NumberFormat().format(number);
        },
        formatdate(value){
         if (value) {
            return moment(String(value)).format('MM/DD/YYYY hh:mm')
          }
      },

    },
    mounted() {
        axios
            .get(
                this.$store.getters.getBaseUrl + "/getTrans/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.school_id+"&org_type_code="+this.user.org_type_code+"&prov_id="+this.user.prov_id+"&district_id="+this.user.district_id
            )
            .then((response) => {
                // JSON responses are automatically parsed.
              //  this.menu = response.data.menu
              this.page++;
                this.pkey = response.data.pkey
                this.table = response.data.table
                this.fields = JSON.parse(response.data.fields)
                this.items = response.data.items
                this.fields.forEach((item) => {
                    this.findfied.push({
                        value: item.key,
                        text: item.label
                    })
                })

            })
            .catch((e) => {
                console.log(e);
            });

    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

       
            //getMenuOne

            axios
            .get(
                this.$store.getters.getBaseUrl + "/getMenuOne/" + this.menuid  +"?level_id="+ this.user.level.level_id,{
                    headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }   
                }
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                console.log(response.data[0])
                this.menu = response.data[0]
             

            })


    },
    methods: {
        goback() {
            this.$router.go(-1)
        },
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        formatDate(dd) {
            let d=new Date(dd)
            return [
                this.padTo2Digits(d.getDate()),
                this.padTo2Digits(d.getMonth() + 1),
                d.getFullYear(),
            ].join('/');
        },
        infiniteHandler($state) {
            this.busy = true;
            setTimeout(() => {

                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/getTrans/" + this.menuid +
                        "?offset=" + this.page + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.school_id+"&org_type_code="+this.user.org_type_code+"&prov_id="+this.user.prov_id+"&district_id="+this.user.district_id,
                        {
                            headers: {
                        'Authorization': 'Bearer ' +  this.user.login_hash
                    }
                        }
                    )
                    .then((response) => {
                        //this.pkey=response.data.pkey
                        if (this.page == 0) {
                            // this.fields = JSON.parse(response.data.fields)

                            // this.fields.forEach((item) => {
                            //     this.findfied.push({
                            //         value: item.key,
                            //         text: item.label
                            //     })
                            // })

                            this.items = response.data.items;
                            this.page++;
                        } else {

                            if (response.data.items.length != 0) {
                                this.page++;
                                this.items = this.items.concat(response.data.items);
                                $state.loaded();
                            }else{

                               $state.complete(); 
                            }
                            
                        }
                    });
                $state.loaded();
                this.busy = false;
            }, 2000);
        },

        onSearch() {
            axios
                .get(
                    this.$store.getters.getBaseUrl + "/getTrans/" + this.menuid + "?offset=0&" + "&fld=" + this.field + "&find=" + this.find +'&branch_id='+this.user.branch_id+"&org_type_code="+this.user.org_type_code+"&prov_id="+this.user.prov_id+"&district_id="+this.user.district_id+"&fdate="+this.fdate,
                    {
                        headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                    }
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.items = response.data.items;
                    this.page = 0;

                })
                .catch((e) => {
                    console.log(e);
                });
        },
        addnew() {
            this.$router.push(this.menu.formnew_web + this.$route.query.id);
        },
        edit(id) {
            //  console.log(this.rowSlect[0].doc_code);
            //  const Values = Object.values(this.rowSlect[0]);
            this.$router.push(
                this.menu.formedit_web  +
                this.$route.query.id +
                "/" +
                this.pkey +
                "/" +
                id
            );
        },
        del(code) {

            let params = {
                fields: {
                    "status": "D",
                        "del_by": this.user.username,
                        "del_date": new Date(),
                },
                pkey: this.pkey,
                id: code
            }
            this.$bvModal.msgBoxConfirm('ກະລຸນາຢືນຢັນ ທ່ານຕ້ອງການລົບລາຍການນີອອກຈາກລະບົບ.', {
                title: 'Please Confirm',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
                .then(value => {
                    if (value == true) {
                        axios.post(this.$store.getters.getBaseUrl + '/deltrans', params,{
                            headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                        })
                            .then((res) => {
                                if (res.data.code == 1) {
                                    this.$bvToast.toast(`ລົບລາຍການອອກສຳເລັດແລ້ວ.`, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })

                                    axios
                                        .get(
                                            this.$store.getters.getBaseUrl + "/getTrans/" + this.menuid + "?offset=0&fld=" + this.field + "&find=" + this.find+'&branch_id='+this.user.branch_id+"&org_type_code="+this.user.org_type_code+"&prov_id"+this.user.prov_id+"&district_id="+this.user.district_id,
                                            {
                                                headers: {
                        'Authorization': 'Bearer ' + this.user.login_hash
                    }
                                            }
                                        )
                                        .then((response) => {
                                            // JSON responses are automatically parsed.
                                            this.pkey = response.data.pkey
                                            this.table = response.data.table
                                            this.fields = JSON.parse(response.data.fields)
                                            this.items = response.data.items
                                            this.fields.forEach((item) => {
                                                this.findfied.push({
                                                    value: item.key,
                                                    text: item.label
                                                })
                                            })

                                        })
                                        .catch((e) => {
                                            console.log(e);
                                        });

                                    this.page = 0

                                } else {
                                    this.$bvToast.toast(res.data.msg, {
                                        title: 'ຂໍ້ຄວາມແຈ້ງກັບ...',
                                        autoHideDelay: 5000,
                                        appendToast: true
                                    })



                                }
                                console.log(res.data)
                            })
                            .catch(err => {

                                console.error(err);
                            })
                    }
                    //this.boxTwo = value
                })
                .catch(err => {
                    console.error(err);
                })

        }
    },

}
</script>

<style scoped>
.feed-trans-page {
    background-color: #f4f7f6;
    min-height: 100vh;
    font-family: 'Noto Sans Lao', sans-serif;
}

.rounded-lg {
    border-radius: 12px !important;
}

.trans-table {
    font-size: 0.9rem;
}

/* ປ້ອງກັນຄຳສັບລົງແຖວ */
.trans-table ::v-deep th,
.trans-table ::v-deep td {
    white-space: nowrap !important;
    vertical-align: middle !important;
    padding: 12px 15px !important;
}

.trans-table ::v-deep thead th {
    background-color: #f8f9fa !important;
    color: #495057;
    font-weight: bold;
    border-top: none;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.action-btn {
    transition: transform 0.2s ease;
}

.action-btn:hover {
    transform: scale(1.2);
}
</style>